
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64"
  xml:space="preserve" width="64" height="64">
  <g class="nc-icon-wrapper" fill="#444444">
    <g class="nc-loop_dots-07-64">
      <circle data-color="color-2" fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10"
        cx="32" cy="32" r="6" transform="translate(9.071078400034459 9.071078400034459) scale(0.7165287999989232)" style="opacity:0.7165287999989232;"
        stroke-linejoin="miter"></circle>
      <circle fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" cx="8" cy="32" r="6"
        stroke-linejoin="miter" style="opacity:0.6834712000010768;" transform="translate(2.532230399991386 10.128921599965544) scale(0.6834712000010768)"></circle>
      <circle fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" cx="56" cy="32" r="6"
        transform="translate(33.6 19.2) scale(0.4)" style="opacity:0.4;" stroke-linejoin="miter"></circle>
    </g>
    <script>
      ! function () {
        function t(t) {
          this.element = t, this.dots = [this.element.getElementsByTagName("circle")[1], this.element.getElementsByTagName(
              "circle")[0], this.element.getElementsByTagName("circle")[2]], this.animationId, this.start = null,
            this.init()
        }
        if (!window.requestAnimationFrame) {
          var e = null;
          window.requestAnimationFrame = function (t, i) {
            var n = (new Date).getTime();
            e || (e = n);
            var a = Math.max(0, 16 - (n - e)),
              s = window.setTimeout(function () {
                t(n + a)
              }, a);
            return e = n + a, s
          }
        }
        t.prototype.init = function () {
          var t = this;
          this.animationId = window.requestAnimationFrame(t.triggerAnimation.bind(t))
        }, t.prototype.reset = function () {
          var t = this;
          window.cancelAnimationFrame(t.animationId)
        }, t.prototype.triggerAnimation = function (t) {
          var e = this;
          this.start || (this.start = t);
          var i = t - this.start,
            n = Math.min(i / 250, 4),
            a = (n = 4 == n ? 0 : n) % 1,
            s = Math.ceil(n);
          1e3 > i || (this.start = this.start + 1e3);
          var r = [],
            o = [8, 32, 56],
            m = [32, 32, 32];
          switch (r[0] = r[1] = r[2] = .4, s) {
            case 1:
              r[0] = 1 - 3 * a / 5, r[1] = .4 + 3 * a / 5;
              break;
            case 2:
              r[1] = 1 - 3 * a / 5, r[2] = .4 + 3 * a / 5;
              break;
            case 3:
              r[1] = .4 + 3 * a / 5, r[2] = 1 - 3 * a / 5;
              break;
            case 4:
              r[0] = .4 + 3 * a / 5, r[1] = 1 - 3 * a / 5;
              break;
            default:
              r[0] = 1
          }
          for (var c = 0; 3 > c; c++) this.dots[c].setAttribute("style", "opacity:" + r[c] + ";"), this.dots[c].setAttribute(
            "transform", "translate(" + (1 - r[c]) * o[c] + " " + (1 - r[c]) * m[c] + ") scale(" + r[c] + ")");
          if (document.documentElement.contains(this.element)) window.requestAnimationFrame(e.triggerAnimation.bind(
            e))
        };
        var i = document.getElementsByClassName("nc-loop_dots-07-64"),
          n = [];
        if (i)
          for (var a = 0; i.length > a; a++) ! function (e) {
            n.push(new t(i[e]))
          }(a);
        document.addEventListener("visibilitychange", function () {
          "hidden" == document.visibilityState ? n.forEach(function (t) {
            t.reset()
          }) : n.forEach(function (t) {
            t.init()
          })
        })
      }();

    </script>
  </g>
</svg>

